import { useGridPageSize } from './useGridPageSize';
import { useGridPage } from './useGridPage';
/**
 * @requires useGridFilter (state)
 * @requires useGridDimensions (event) - can be after
 */

export const useGridPagination = (apiRef, props) => {
  useGridPageSize(apiRef, props);
  useGridPage(apiRef, props);
};